import { Injectable } from '@angular/core';
import { SnackService } from './snack.service';
import { HttpClient } from '@angular/common/http';
import { serverurl } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  allUnreadMessages = new BehaviorSubject<any[]>([]);

  constructor(
    private http: HttpClient,
    private snack: SnackService
  ) {
    this.getUnreadMessages();
    setTimeout(() => {
      this.getUnreadMessages();
    }, 60000 * 5);
  }

  getUnreadMessages() {
    return new Promise((resolve) => {
      this.http.get(serverurl + '/messages').subscribe({
        next: (data: any) => {
          // console.log('UNREAD MESSAGES', data);

          this.allUnreadMessages.next(data);
          resolve(true);
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      });
    });
  }
  getAllMessages() {
    return new Promise((resolve) => {
      this.http.get(serverurl + '/messages/all').subscribe({
        next: (data: any) => {
          resolve(true);
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      });
    });
  }
  updateReadStatus(messageId: string) {
    return new Promise((resolve) => {
      this.http.put(serverurl + '/messages/seen', { messageId }).subscribe({
        next: (data: any) => {
          resolve(true);
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      });
    });
  }
  deleteMessage(messageId: string) {
    return new Promise((resolve) => {
      this.http.delete(serverurl + '/messages/' + messageId).subscribe({
        next: (data: any) => {
          resolve(true);
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      });
    });
  }
}
